import { Koi } from '@ksyos/koi';
import { OsasQuestionnaireName } from '../../enums/OsasQuestionnaireName';
import { SleepQuestionnairesValidationType } from '../../enums/SleepQuestionnairesValidationType';

export enum SleepRecorderType {
    nightowl = 'nightowl',
    nightowlReusable = 'NightOwl Reusable',
    watchpat = 'watchpat',
    watchpat300 = 'WatchPAT 300',
    watchpatOne = 'WatchPAT ONE',
}

export enum SendSleepRecorderOption {
    giveToThePatientKsyos = 'giveToThePatientKsyos',
    sendByKsyos = 'sendByKsyos',
}

export const essQuestionOptions = [
    { label: 'ik zou nooit indutten', value: 0 },
    { label: 'ik zou af en toe indutten', value: 1 },
    { label: 'ik zou vrij vaak indutten', value: 2 },
    { label: 'ik zou altijd indutten', value: 3 },
];

export interface IEssQuestionnaireCustomControlData {
    afterLunch: number | null;
    inAPublicEnvironment: number | null;
    restingInTheAfternoon: number | null;
    sittingInACarAsPassenger: number | null;
    talkingToSomeone: number | null;
    waitingInTheCarInTraffic: number | null;
    whenReading: number | null;
    whenWatchingTv: number | null;
}

export const step1EssQuestionnaireSchema = {
    schema: Koi.object().keys({
        inAPublicEnvironment: Koi.number().min(0).max(3),
        sittingInACarAsPassenger: Koi.number().min(0).max(3),
        whenReading: Koi.number().min(0).max(3),
        whenWatchingTv: Koi.number().min(0).max(3),
    }),
};

export const step2EssQuestionnaireSchema = {
    schema: Koi.object().keys({
        afterLunch: Koi.number().min(0).max(3),
        restingInTheAfternoon: Koi.number().min(0).max(3),
        talkingToSomeone: Koi.number().min(0).max(3),
        waitingInTheCarInTraffic: Koi.number().min(0).max(3),
    }),
};

export const essQuestionnaireFinalSchema = {
    schema: step1EssQuestionnaireSchema.schema.concat(step2EssQuestionnaireSchema.schema),
};

export const essQuestionnaireDraftSchema = {
    schema: Koi.object().keys({
        afterLunch: Koi.number().min(0).max(3).allow(null),
        inAPublicEnvironment: Koi.number().min(0).max(3).allow(null),
        restingInTheAfternoon: Koi.number().min(0).max(3).allow(null),
        sittingInACarAsPassenger: Koi.number().min(0).max(3).allow(null),
        talkingToSomeone: Koi.number().min(0).max(3).allow(null),
        waitingInTheCarInTraffic: Koi.number().min(0).max(3).allow(null),
        whenReading: Koi.number().min(0).max(3).allow(null),
        whenWatchingTv: Koi.number().min(0).max(3).allow(null),
    }),
};

export interface IFosq10QuestionnaireCustomControlData {
    difficultyBeingActiveAtNight: number | null;
    difficultyBeingActiveInTheMorning: number | null;
    difficultyConcentratingOnWork: number | null;
    difficultyDrivingAVehicleLongDistances: number | null;
    difficultyDrivingAVehicleShortDistances: number | null;
    difficultyRememberingThings: number | null;
    difficultyVisitingFriendsAndFamily: number | null;
    difficultyWatchingVideoOrFilm: number | null;
    haveRelationshipsDeteriorated: number | null;
    needForIntimacy: number | null;
}

export const step1Fosq10QuestionnaireSchema = {
    schema: Koi.object().keys({
        difficultyConcentratingOnWork: Koi.number().min(1).max(4),
        difficultyDrivingAVehicleLongDistances: Koi.number().min(0).max(4),
        difficultyDrivingAVehicleShortDistances: Koi.number().min(0).max(4),
        difficultyRememberingThings: Koi.number().min(1).max(4),
    }),
};

export const step2Fosq10QuestionnaireSchema = {
    schema: Koi.object().keys({
        difficultyBeingActiveAtNight: Koi.number().min(1).max(4),
        difficultyBeingActiveInTheMorning: Koi.number().min(1).max(4),
        difficultyVisitingFriendsAndFamily: Koi.number().min(0).max(4),
        difficultyWatchingVideoOrFilm: Koi.number().min(0).max(4),
        haveRelationshipsDeteriorated: Koi.number().min(1).max(4),
        needForIntimacy: Koi.number().min(0).max(4),
    }),
};

export const partialFosq10QuestionOptions = [
    { label: 'Ja, zeer', value: 1 },
    { label: 'Ja, matig', value: 2 },
    { label: 'Ja, een beetje', value: 3 },
    { label: 'Nee', value: 4 },
];

export const completeFosq10QuestionOptions = [
    ...partialFosq10QuestionOptions,
    { label: 'Ik doe dit niet om andere redenen', value: 0 },
];

export const fosq10QuestionnaireFinalSchema = {
    schema: step1Fosq10QuestionnaireSchema.schema.concat(step2Fosq10QuestionnaireSchema.schema),
};

export const fosq10QuestionnaireDraftSchema = {
    schema: Koi.object().keys({
        difficultyBeingActiveAtNight: Koi.number().min(1).max(4).allow(null),
        difficultyBeingActiveInTheMorning: Koi.number().min(1).max(4).allow(null),
        difficultyConcentratingOnWork: Koi.number().min(1).max(4).allow(null),
        difficultyDrivingAVehicleLongDistances: Koi.number().min(0).max(4).allow(null),
        difficultyDrivingAVehicleShortDistances: Koi.number().min(0).max(4).allow(null),
        difficultyRememberingThings: Koi.number().min(1).max(4).allow(null),
        difficultyVisitingFriendsAndFamily: Koi.number().min(0).max(4).allow(null),
        difficultyWatchingVideoOrFilm: Koi.number().min(0).max(4).allow(null),
        haveRelationshipsDeteriorated: Koi.number().min(1).max(4).allow(null),
        needForIntimacy: Koi.number().min(0).max(4).allow(null),
    }),
};

export const hsdqQuestionOptions = [
    { label: 'Helemaal wel', value: 5 },
    { label: 'Meestal wel', value: 4 },
    { label: 'Soms wel, soms niet', value: 3 },
    { label: 'Meestal niet', value: 2 },
    { label: 'Helemaal niet', value: 1 },
];

export interface IHsdqQuestionnaireProcedureAddValidated {
    customControlData: IHsdqQuestionnaireCustomControlData;
    procedureId?: string;
}

export interface IHsdqQuestionnaireCustomControlData {
    annoyingItchy: number | null;
    concerned: number | null;
    confusedHalfAwake: number | null;
    consequencesAfterBadNight: number | null;
    difficultyWakingUp: number | null;
    dryMouth: number | null;
    fallAsleepRepeatedly: number | null;
    fatigueDuringTheDay: number | null;
    functionLessWell: number | null;
    iDontFeelRestedAfterNap: number | null;
    iDontGetEnoughSleep: number | null;
    kickingLegMovements: number | null;
    lieAwake: number | null;
    moreThanTenHours: number | null;
    moveLegs: number | null;
    nightmares: number | null;
    normalTime: number | null;
    poorSleep: number | null;
    restlessLegs: number | null;
    screaming: number | null;
    sleepAttacks: number | null;
    sleepBadlyDuringDay: number | null;
    sleepWalking: number | null;
    snoreLoudly: number | null;
    sometimesInjured: number | null;
    stopBreathing: number | null;
    suffocation: number | null;
    timeVaries: number | null;
    troublesFallingAsleep: number | null;
    unintentionallyFallAsleepDuringDay: number | null;
    urgeToMoveLegs: number | null;
    vividDream: number | null;
}

export const step1hsdqQuestionnaireSchema = {
    schema: Koi.object().keys({
        annoyingItchy: Koi.number().min(1).max(5),
        difficultyWakingUp: Koi.number().min(1).max(5),
        dryMouth: Koi.number().min(1).max(5),
        fatigueDuringTheDay: Koi.number().min(1).max(5),
        screaming: Koi.number().min(1).max(5),
    }),
};

export const step2hsdqQuestionnaireSchema = {
    schema: Koi.object().keys({
        lieAwake: Koi.number().min(1).max(5),
        moveLegs: Koi.number().min(1).max(5),
        poorSleep: Koi.number().min(1).max(5),
        restlessLegs: Koi.number().min(1).max(5),
        urgeToMoveLegs: Koi.number().min(1).max(5),
    }),
};

export const step3hsdqQuestionnaireSchema = {
    schema: Koi.object().keys({
        concerned: Koi.number().min(1).max(5),
        consequencesAfterBadNight: Koi.number().min(1).max(5),
        iDontGetEnoughSleep: Koi.number().min(1).max(5),
        kickingLegMovements: Koi.number().min(1).max(5),
        troublesFallingAsleep: Koi.number().min(1).max(5),
    }),
};

export const step4hsdqQuestionnaireSchema = {
    schema: Koi.object().keys({
        nightmares: Koi.number().min(1).max(5),
        snoreLoudly: Koi.number().min(1).max(5),
        stopBreathing: Koi.number().min(1).max(5),
        suffocation: Koi.number().min(1).max(5),
        vividDream: Koi.number().min(1).max(5),
    }),
};

export const step5hsdqQuestionnaireSchema = {
    schema: Koi.object().keys({
        confusedHalfAwake: Koi.number().min(1).max(5),
        fallAsleepRepeatedly: Koi.number().min(1).max(5),
        functionLessWell: Koi.number().min(1).max(5),
        iDontFeelRestedAfterNap: Koi.number().min(1).max(5),
        sometimesInjured: Koi.number().min(1).max(5),
    }),
};

export const step6hsdqQuestionnaireSchema = {
    schema: Koi.object().keys({
        moreThanTenHours: Koi.number().min(1).max(5),
        normalTime: Koi.number().min(1).max(5),
        sleepAttacks: Koi.number().min(1).max(5),
        sleepBadlyDuringDay: Koi.number().min(1).max(5),
        timeVaries: Koi.number().min(1).max(5),
    }),
};

export const step7hsdqQuestionnaireSchema = {
    schema: Koi.object().keys({
        sleepWalking: Koi.number().min(1).max(5),
        unintentionallyFallAsleepDuringDay: Koi.number().min(1).max(5),
    }),
};

export const hsdqQuestionnaireFinalSchema = {
    schema: step1hsdqQuestionnaireSchema.schema
        .concat(step2hsdqQuestionnaireSchema.schema)
        .concat(step3hsdqQuestionnaireSchema.schema)
        .concat(step4hsdqQuestionnaireSchema.schema)
        .concat(step5hsdqQuestionnaireSchema.schema)
        .concat(step6hsdqQuestionnaireSchema.schema)
        .concat(step7hsdqQuestionnaireSchema.schema),
};

export const hsdqQuestionnaireDraftSchema = {
    schema: Koi.object().keys({
        annoyingItchy: Koi.number().min(1).max(5).allow(null),
        concerned: Koi.number().min(1).max(5).allow(null),
        confusedHalfAwake: Koi.number().min(1).max(5).allow(null),
        consequencesAfterBadNight: Koi.number().min(1).max(5).allow(null),
        difficultyWakingUp: Koi.number().min(1).max(5).allow(null),
        dryMouth: Koi.number().min(1).max(5).allow(null),
        fallAsleepRepeatedly: Koi.number().min(1).max(5).allow(null),
        fatigueDuringTheDay: Koi.number().min(1).max(5).allow(null),
        functionLessWell: Koi.number().min(1).max(5).allow(null),
        iDontFeelRestedAfterNap: Koi.number().min(1).max(5).allow(null),
        iDontGetEnoughSleep: Koi.number().min(1).max(5).allow(null),
        kickingLegMovements: Koi.number().min(1).max(5).allow(null),
        lieAwake: Koi.number().min(1).max(5).allow(null),
        moreThanTenHours: Koi.number().min(1).max(5).allow(null),
        moveLegs: Koi.number().min(1).max(5).allow(null),
        nightmares: Koi.number().min(1).max(5).allow(null),
        normalTime: Koi.number().min(1).max(5).allow(null),
        poorSleep: Koi.number().min(1).max(5).allow(null),
        restlessLegs: Koi.number().min(1).max(5).allow(null),
        screaming: Koi.number().min(1).max(5).allow(null),
        sleepAttacks: Koi.number().min(1).max(5).allow(null),
        sleepBadlyDuringDay: Koi.number().min(1).max(5).allow(null),
        sleepWalking: Koi.number().min(1).max(5).allow(null),
        snoreLoudly: Koi.number().min(1).max(5).allow(null),
        sometimesInjured: Koi.number().min(1).max(5).allow(null),
        stopBreathing: Koi.number().min(1).max(5).allow(null),
        suffocation: Koi.number().min(1).max(5).allow(null),
        timeVaries: Koi.number().min(1).max(5).allow(null),
        troublesFallingAsleep: Koi.number().min(1).max(5).allow(null),
        unintentionallyFallAsleepDuringDay: Koi.number().min(1).max(5).allow(null),
        urgeToMoveLegs: Koi.number().min(1).max(5).allow(null),
        vividDream: Koi.number().min(1).max(5).allow(null),
    }),
};

export type QuestionnaireCustomControlData =
    | IEssQuestionnaireCustomControlData
    | IFosq10QuestionnaireCustomControlData
    | IHsdqQuestionnaireCustomControlData;
export type QuestionnaireCustomControlKeys =
    | keyof IEssQuestionnaireCustomControlData
    | keyof IFosq10QuestionnaireCustomControlData
    | keyof IHsdqQuestionnaireCustomControlData;

export interface IQuestionnaireProcedureAddValidated {
    customControlData: QuestionnaireCustomControlData;
    procedureId: string;
}

export interface IOSASQuestionnaire {
    procedureId: string;
    questionnaire: {
        answer: QuestionnaireCustomControlData;
        name: OsasQuestionnaireName;
        validationType: SleepQuestionnairesValidationType;
    };
}

export const stepSchemas = {
    [OsasQuestionnaireName.ess]: {
        1: step1EssQuestionnaireSchema,
        2: step2EssQuestionnaireSchema,
    },
    [OsasQuestionnaireName.fosq10]: {
        1: step1Fosq10QuestionnaireSchema,
        2: step2Fosq10QuestionnaireSchema,
    },
    [OsasQuestionnaireName.hsdq]: {
        1: step1hsdqQuestionnaireSchema,
        2: step2hsdqQuestionnaireSchema,
        3: step3hsdqQuestionnaireSchema,
        4: step4hsdqQuestionnaireSchema,
        5: step5hsdqQuestionnaireSchema,
        6: step6hsdqQuestionnaireSchema,
        7: step7hsdqQuestionnaireSchema,
    },
};

export const questionnaireValidationTypes = {
    [OsasQuestionnaireName.ess]: {
        draft: SleepQuestionnairesValidationType.essDraft,
        final: SleepQuestionnairesValidationType.essFinal,
    },
    [OsasQuestionnaireName.fosq10]: {
        draft: SleepQuestionnairesValidationType.fosq10Draft,
        final: SleepQuestionnairesValidationType.fosq10Final,
    },
    [OsasQuestionnaireName.hsdq]: {
        draft: SleepQuestionnairesValidationType.hsdqDraft,
        final: SleepQuestionnairesValidationType.hsdqFinal,
    },
};

export function getSendQuestionnaireValidationSchema(validationType: SleepQuestionnairesValidationType) {
    let questionnaireSchema;
    switch (validationType) {
        case SleepQuestionnairesValidationType.essDraft:
            questionnaireSchema = Koi.object({
                answer: essQuestionnaireDraftSchema.schema,
                name: Koi.string().valid(OsasQuestionnaireName.ess),
            });
            break;
        case SleepQuestionnairesValidationType.essFinal:
            questionnaireSchema = Koi.object({
                answer: essQuestionnaireFinalSchema.schema,
                name: Koi.string().valid(OsasQuestionnaireName.ess),
            });
            break;
        case SleepQuestionnairesValidationType.fosq10Draft:
            questionnaireSchema = Koi.object({
                answer: fosq10QuestionnaireDraftSchema.schema,
                name: Koi.string().valid(OsasQuestionnaireName.fosq10),
            });
            break;
        case SleepQuestionnairesValidationType.fosq10Final:
            questionnaireSchema = Koi.object({
                answer: fosq10QuestionnaireFinalSchema.schema,
                name: Koi.string().valid(OsasQuestionnaireName.fosq10),
            });
            break;
        case SleepQuestionnairesValidationType.hsdqDraft:
            questionnaireSchema = Koi.object({
                answer: hsdqQuestionnaireDraftSchema.schema,
                name: Koi.string().valid(OsasQuestionnaireName.hsdq),
            });
            break;
        case SleepQuestionnairesValidationType.hsdqFinal:
            questionnaireSchema = Koi.object({
                answer: hsdqQuestionnaireFinalSchema.schema,
                name: Koi.string().valid(OsasQuestionnaireName.hsdq),
            });
            break;
        default:
            throw new Error('Unable to find validation schema');
    }

    return Koi.object({
        procedureId: Koi.string().uuid(),
        questionnaire: questionnaireSchema,
        validationType: Koi.koi().enum(SleepQuestionnairesValidationType).disallow(null),
    }).options({ presence: 'required' });
}
